import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function CTASection() {
  return (
    <section
      data-testid="cta-section"
      className="relative border-t border-[var(--ri-ink)] bg-[var(--ri-bg)] overflow-hidden"
    >
      <div className="ri-container py-24 md:py-32 relative">
        <div
          aria-hidden
          className="absolute inset-0 grid-bg-dense opacity-50 pointer-events-none"
        />
        <div className="relative grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-8">
            <div className="overline mb-5">
              <span className="dot mr-2" /> Ready / Onboard
            </div>
            <h2 className="font-display text-5xl md:text-7xl tracking-tighter leading-[0.92]">
              Setup a future-tech lab<br />
              in your school —{" "}
              <span className="bg-[var(--ri-orange)] text-white px-3">
                in 30 days.
              </span>
            </h2>
            <p className="mt-7 text-[var(--ri-muted)] max-w-2xl text-lg">
              From procurement to first class, we ship a complete robotics, AI, IoT, app-dev or 3D-printing capability — wired, taught, supported.
            </p>
          </div>
          <div className="lg:col-span-4 flex flex-col gap-4">
            <Link
              to="/contact"
              className="btn-primary justify-center"
              data-testid="cta-section-book"
            >
              Book RoboInsci program <ArrowUpRight size={14} />
            </Link>
            <Link
              to="/contact"
              className="btn-ghost justify-center"
              data-testid="cta-section-demo"
            >
              Request a demo <ArrowUpRight size={14} />
            </Link>
            <Link
              to="/contact"
              className="btn-ghost justify-center bg-[var(--ri-ink)] text-white"
              data-testid="cta-section-lab"
            >
              Setup lab with Gakuen <ArrowUpRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
